// extracted by mini-css-extract-plugin
export default {"uncheckedBorderColor":"#a0a0a0","checkedFillColor":"#2962ff"};